import React, { Suspense } from "react";
import Banner from "./Banner";
import About from "./About";
import Gallery from "./Gallery";
import Testimonials from "./Testimonials";
import Featured from "./Featured";
import Listings from "./Listings";
import DynamicSeoPage from "../DynamicSeoPage";
import NewHome from "./NewHome";

const Home = () => {
  return (
    <>
      {/* <DynamicSeoPage
        page="home"
        defalut={"365 Luxury Homes - Find your Vacation Holiday in Dubai"}
      />
      <Suspense>
        <Banner />
      </Suspense>
      <Suspense>
        <Listings />
      </Suspense>
      <Suspense>
        <Gallery />
      </Suspense>
      <About />
      <Featured />
      <Testimonials /> */}
      <NewHome />
    </>
  );
};

export default Home;
